import { FC } from "react";
import { Address } from "../../types/address";
import AddressFormStyled from "./AddressFormStyled";
import BaseControlledAutoComplete from "./BaseControlledAutoComplete";

interface Props {
  apiVersion: string;
  selectedAddress: Address;
  setSelectedAddress: (address: Address) => void;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitCallBack: (event: any) => void;
}

const AutoComplete: FC<Props> = ({ apiVersion, selectedAddress, setSelectedAddress, placeholder, submitCallBack }) => {
  return (
    <AddressFormStyled>
      <div className="address-form__inputs address-form__inputs--auto-complete">
        <BaseControlledAutoComplete
          apiVersion={apiVersion}
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          placeholder={placeholder || "Enter your address"}
          submitCallBack={submitCallBack}
          withBorderStyles={false}
          enableTabNavigation={true}
          triggerSuggestionsOnFocus={false}
          inputId="street-address"
          showLabel={true}
          labelText="Enter your address to check availability"
          containerClassName="address-form__input address-form__input--auto-complete"
          testId="street-address"
        />
      </div>
    </AddressFormStyled>
  );
};

AutoComplete.displayName = "AutoComplete";

export default AutoComplete;
